export const IconPeopleExtensiveCoverage20: {
  name: 'icon_people_extensive_coverage_20-5e773c269ac9'
} = {
  name: 'icon_people_extensive_coverage_20-5e773c269ac9'
}
